import React from 'react';
import PropTypes from 'prop-types';
import RecordCollectionContentTypeTag from './RecordCollectionContentTypeTag';

const RecordCollectionContentType = ({ id, collection, loading = false }) => {
  const contentType = collection?.contentType;
  const status = !id
      ? 'not_selected'
      : contentType
          ? 'has_content'
          : 'missing';

  return (
    <RecordCollectionContentTypeTag
      label={contentType}
      status={status}
      loading={loading}
    />
  );
};

RecordCollectionContentType.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  collection: PropTypes.object,
  loading: PropTypes.bool
};

export default RecordCollectionContentType;